export default {
  background_image: 'Baggrundsbillede',
  file_too_large: 'Filen er for stor. Maksimal størrelse er {{max}} MB.',
  upload_failed: 'Upload mislykkedes. Prøv igen.',
};
